import UserTrederoCustomKYCForm from './UserTrederoCustomKYCForm';

export default UserTrederoCustomKYCForm;
